import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

export const TableScroll = styled.div`
  position: relative;
  overflow-x: auto;
`;

export const Table = styled.table`
  position: relative;
  border-collapse: collapse;
  color: var(--colors-darkBlue);
  min-width: 680px;
`;

export const BaseCellStyle = css`
  ${fluidProp(['padding-left', 'padding-right'], '5px', '20px')}
  border-bottom: 1px solid #d4d7df;

  &:first-child {
    padding-left: 0;
  }
`;

export const HeaderCell = styled.th`
  ${BaseCellStyle}
  color: var(--colors-bayoux);
  ${({ theme }) => theme.typography.bodySMBold}
  text-transform: uppercase;
  text-align: left;
  padding-top: 20px;
  padding-bottom: 20px;
  position: sticky;
  top: 0;

  tfoot & {
    border: none;
  }
`;

export const PlanLabelCell = styled(HeaderCell)`
  color: var(--colors-irisBlue);
  text-align: center;
  width: 20%;
`;

export const Cell = styled.td`
  ${BaseCellStyle}
`;

export const FooterCell = styled.td`
  ${BaseCellStyle}
  ${fluidProp(['padding-top', 'padding-bottom'], '10px', '40px')}
  border: none;
`;
